module.exports = __webpack_public_path__ + "img/gym_thumbnail-600x450.da0b46a6.jpg";